/**
 * Copyright (C) SiteVision AB 2002-2015, all rights reserved
 *
 * HTML template utils (micro version of _.template)
 *
 * @author Henrik Ekelöf
 *
 */
import sv from '@sv/core';
import $ from '@sv/jquery';

// Simple JavaScript Templating
// John Resig - http://ejohn.org/ - MIT Licensed
// http://ejohn.org/blog/javascript-micro-templating/

const cache = {};

export const template = function (str, data) {
  var fn = !/\W/.test(str)
    ? (cache[str] =
        cache[str] || template(document.getElementById(str).innerHTML))
    : new Function(
        'obj',
        'var p=[],print=function(){p.push.apply(p, arguments);};' +
          "with(obj){p.push('" +
          str
            .replace(/[\r\t\n]/g, ' ')
            .split('<%')
            .join('\t')
            .replace(/((^|%>)[^\t]*)'/g, '$1\r')
            .replace(/\t=(.*?)%>/g, "',$1,'")
            .split('\t')
            .join("');")
            .split('%>')
            .join("p.push('")
            .split('\r')
            .join("\\'") +
          "');}return p.join('');"
      );
  return data ? fn(data) : fn;
};

export const htmlEncode = function (value) {
  //create a in-memory div, set it's inner text(which jQuery automatically encodes)
  //then grab the encoded contents back out.  The div never exists on the page.
  return $('<div/>').text(value).html();
};

sv.TemplateUtil = {
  template,
  htmlEncode,
};
